<button class="btn btn-lg btn-primary btn-block mt-2 text-white" (click)="redirectToExternalProvider()">
  <i class="fas fa-sign-in-alt"></i> {{getButtonLabel() | translate}}
</button>
